export const EVENT = {
  MARKER_CLICK: 'markerClick',
  DRAGGING: 'dragging',
  DRAGEND: 'dragend',
  MOUSEMOVE: 'mousemove',
  MOUSELEAVE: 'mouseleave',
} as const;
